import dynamic from 'next/dynamic';

import { LOTTIE_SUBSCRIPTION_PATH } from 'src/utils/constants/stringConstants';

import { mixpanelObject } from '../../../../utils/analytics/mixpanel/mixpanel';
import {
  MIXPANEL_ELEMENT,
  MIXPANEL_IS_PREMIUM_CONTENT,
  MIXPANEL_NO,
  MIXPANEL_PRE_ROLL_BUY_PLAN
} from '../../../../utils/analytics/mixpanel/mixpanelConstants';
import { playerCtaEvent } from '../../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { clearCtaEventsProperty } from '../../../../utils/analytics/mixpanel/mixpanelHelper';
import { getsubscribeToPremium } from '../../../../utils/playerHelper';
import { getSpecialPriceText } from '../../../../utils/VideoPlayerUtils/Utils';
import { goToSubscription } from '../playerCallbacks';

const LottieComponent = dynamic(
  () => import('src/components/LottieComponent/LottieComponent'),
  {
    ssr: false
  }
);
type SubscriptionNudgeProps = {
  playerRef: any;
  closePopUp: any;
  toggleTeaserSubscriptionPopup: any;
};

const SubscriptionNudge = ({
  playerRef,
  closePopUp,
  toggleTeaserSubscriptionPopup
}: SubscriptionNudgeProps) => {
  const { playerConfig = {} } = playerRef || {};
  const {
    userData: { user = {} } = {},
    country = 'IN',
    tvodObj = null
  } = playerConfig || {};
  const { messages = {} } = window.translationsAndConfigs || {};

  const createLottieAnimation = () => {
    return (
      <div className="lottie-position">
        <LottieComponent path={LOTTIE_SUBSCRIPTION_PATH} />
      </div>
    );
  };

  const buyPlanBtnClick = () => {
    if (
      window.isRevisedSubscriptionJourney &&
      country &&
      country.toLowerCase() === 'in'
    ) {
      clearCtaEventsProperty(mixpanelObject);
      toggleTeaserSubscriptionPopup(true);
      mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_PRE_ROLL_BUY_PLAN;
      mixpanelObject[MIXPANEL_IS_PREMIUM_CONTENT] = MIXPANEL_NO;
      playerCtaEvent(true);
    } else {
      clearCtaEventsProperty(mixpanelObject);
      mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_PRE_ROLL_BUY_PLAN;
      mixpanelObject[MIXPANEL_IS_PREMIUM_CONTENT] = MIXPANEL_NO;
      playerCtaEvent(true);
      goToSubscription({ country, tvodObj });
    }
  };

  const subscriptionMessage = () => {
    return (
      <div className="subscription-msg-avod">
        {getSpecialPriceText(messages.NewNudge_AVODMessage_Text)}
      </div>
    );
  };
  const createBuyPlanButton = () => {
    return (
      <div
        className={`subscribe-button buy-plan-btn subscribemsg_${messages.localeLanguage} noPremiumIcon`}
        onClick={() => buyPlanBtnClick()}>
        {getsubscribeToPremium(country)}
      </div>
    );
  };
  const continueWatchingButton = () => {
    return (
      <div
        className="continue-watching-btn"
        onClick={() => continueWatchBtnClick()}>
        {messages.NewNudge_ContinueWatching_CTA}
        <div className="continue-watching-btn-white" id="continue-div">
          {messages.NewNudge_ContinueWatching_CTA}
        </div>
      </div>
    );
  };
  const continueWatchBtnClick = () => {
    closePopUp();
  };

  return (
    <>
      {createLottieAnimation()}
      <div className="main-Inner-container">
        {subscriptionMessage()}
        {createBuyPlanButton()}
        {continueWatchingButton()}
      </div>
    </>
  );
};

export default SubscriptionNudge;
